import clsx from 'clsx'
import { Card, Col, Select, Title } from 'components/common'

export interface UsageTimezoneCardProps {
  title?: string
}

export const UsageTimezoneCard = ({
  title,
}: UsageTimezoneCardProps): JSX.Element => {
  return (
    <>
      <Col span={24} className={clsx('mb-3')}>
        <Card>
          <Title level={5}>{title}</Title>
          <Select placeholder="9:00 - 12:00" style={{ width: '100%' }}>
            <Select.Option value="value1">9:00 - 12:00</Select.Option>
            <Select.Option value="value2">10:00 - 13:00</Select.Option>
            <Select.Option value="value3">11:00 - 14:00</Select.Option>
            <Select.Option value="value4">12:00 - 15:00</Select.Option>
          </Select>
        </Card>
      </Col>
    </>
  )
}
